import React from 'react';
import { Constants } from '@eagerdog/constants';

import type { CustomCellRendererProps } from 'ag-grid-react';

import styles from "./ResultsTab.module.scss";

const getChipClass = (value: string): string => {
  const { qualified, not_qualified, failed, scratched, conflict, disqualified, excused, absent } = Constants.score_result_type;
  const { complete } = Constants.score_status;
  const { pass, fail, abs } = Constants.cwags_scent_result;

  switch (value) {
    case qualified: case complete: case 'passed': case pass: return styles.qualified;
    case absent: case excused: case 'weighed': case abs: case Constants.score_status.pending: return styles.pending;
    case not_qualified: case disqualified: case failed: case fail: case 'nq': return styles.not_qualified;
    case scratched: return styles.scratched;
    case conflict: return styles.conflict;
    default: return '';
  }
};

export const ResultRenderer = (props: CustomCellRendererProps & { showPending?: boolean }) => {
  // Handle null/undefined values
  if (!props.value) {
    if (props.showPending) {
      return (<div className={styles.ResultRenderer}>
        <div className={`${styles.status} ${styles.pending}`}>Pending</div>
      </div>);
    }
    return (<div className={styles.ResultRenderer}>
      <div className={styles.status}></div>
    </div>);
  }
  
  let displayValue = props.value;

  if (props.value === Constants.cwags_scent_result.pass) {
    displayValue = "Pass";
  } else if (props.value === Constants.cwags_scent_result.fail) {
    displayValue = "Fail";
  } else if (props.value === Constants.cwags_scent_result.abs) {
    displayValue = "ABS";
  } else {
    displayValue = props.value.replace(/_/g, ' ');
  }

  const chipClass = getChipClass(props.value);

  return (<div className={styles.ResultRenderer}>
    <div className={`${styles.status} ${chipClass}`}>{displayValue}</div>
  </div>);
};